import { Navigate, useLocation } from 'react-router-dom';
import { Wind } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Wraps a route that requires a user account. Unlike ProtectedRoute (which
 * redirects to plain /login), this variant sends anonymous visitors to
 * /login?next=<current-path> so returning users see the login form by default.
 * New visitors still get a prominent "Pas de compte ? Inscrivez-vous" link
 * directly below the form. After login/registration, they land on the target
 * page. Approved users see the wrapped content directly.
 */
const RegisterRequiredRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-teal-50 flex items-center justify-center">
        <div className="text-center">
          <Wind className="w-12 h-12 text-teal-500 mx-auto animate-pulse" />
          <p className="mt-4 text-stone-500">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
};

export default RegisterRequiredRoute;
